export interface NavItem {
  label: string;
  path: string;
  icon: string;
}

export interface NavSeparator {
  separator: true;
}

export type SidebarEntry = NavItem | NavSeparator;

export function isSeparator(entry: SidebarEntry): entry is NavSeparator {
  return "separator" in entry;
}

export const navEntries: SidebarEntry[] = [
  { label: "Dashboard", path: "/", icon: "◉" },
  { label: "Device Groups", path: "/device-groups", icon: "⊞" },
  {
    label: "Certificate Policies",
    path: "/certificate-policies",
    icon: "⛨",
  },
  { label: "Certificates", path: "/certificates", icon: "🔒" },
  { label: "Devices", path: "/devices", icon: "📱" },
  { separator: true },
  { label: "Notifications", path: "/notifications", icon: "🔔" },
  { separator: true },
  { label: "Admin", path: "/admin", icon: "👤" },
  // Keep Help near the bottom so onboarding is always easy to find but out of the core workflow path.
  { label: "Help", path: "/help", icon: "❓" },
];
